export default __webpack_public_path__ + "static/media/yooz_tac.3ef5e047.pdf";